module.exports = __webpack_public_path__ + "img/es.d651a5fb.svg";